// client/src/services/cryptoService.js

import authService from './authService';

const apiUrl = process.env.REACT_APP_API_URL || '/api';
const baseUrl = `${apiUrl}/investments/crypto`;

const authHeaders = (extra = {}) => ({
  ...extra,
  Authorization: `Bearer ${authService.getToken()}`
});

const checkUnauthorized = (response) => {
  if (response.status === 401) authService.handleUnauthorized();
};

// Remonte le message d'erreur du serveur quand il y en a un.
const handle = async (response, fallback) => {
  checkUnauthorized(response);
  const result = await response.json().catch(() => null);
  if (!response.ok) throw new Error((result && result.message) || fallback);
  return result;
};

const getOverview = async () => {
  const response = await fetch(`${baseUrl}/overview`, { headers: authHeaders() });
  return handle(response, 'Erreur lors du chargement des cryptos.');
};

const createWallet = async (data) => {
  const response = await fetch(`${baseUrl}/wallets`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(data)
  });
  return handle(response, "Erreur lors de l'ajout du wallet.");
};

const deleteWallet = async (id) => {
  const response = await fetch(`${baseUrl}/wallets/${id}`, {
    method: 'DELETE',
    headers: authHeaders()
  });
  return handle(response, 'Erreur lors de la suppression du wallet.');
};

const syncWallet = async (id) => {
  const response = await fetch(`${baseUrl}/wallets/${id}/sync`, {
    method: 'POST',
    headers: authHeaders()
  });
  return handle(response, 'Erreur lors de la synchronisation.');
};

const updateHolding = async (id, data) => {
  const response = await fetch(`${baseUrl}/holdings/${id}`, {
    method: 'PATCH',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(data)
  });
  return handle(response, 'Erreur lors de la mise à jour de la ligne.');
};

const cryptoService = {
  getOverview,
  createWallet,
  deleteWallet,
  syncWallet,
  updateHolding
};

export default cryptoService;
